import { Label } from "@braze/beacon-core"
import { styled } from "styled-components";


export const ViewTitle = ({title}:{title:string}) => {

    return (
        
        <StyledLabel>{title}</StyledLabel>
        
    )
}

const StyledLabel = styled(Label)`
    color: #2e3c47;
    font-size: 30px;
    letter-spacing: -0.75px;
    line-height: 40px;
    font-weight: normal;
    -webkit-font-smoothing: antialiased;
    cursor: pointer;
    margin-bottom: 1em;
`
